import * as React from "react";
const SvgCircularGreenMark = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={31}
    height={31}
    fill="none"
    {...props}
  >
    <path
      stroke="#389C7B"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={2.25}
      d="m9.112 15.015 3.93 3.93 7.876-7.86m-5.903 17.82c7.64 0 13.89-6.25 13.89-13.89s-6.25-13.89-13.89-13.89-13.89 6.25-13.89 13.89 6.25 13.89 13.89 13.89"
    />
  </svg>
);
export default SvgCircularGreenMark;
